<template>
  <b-navbar
    toggleable="lg"
    type="light"
    variant="light"
    class="nav"
  >
    <b-navbar-brand href="#">
      <img
        class="d-inline-block align-top"
        src="@/assets/logo.png"
        width="200"
        height="48"
        alt="Omnigo"
      >
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse" />

    <b-collapse
      id="nav-collapse"
      is-nav
    >
      <b-navbar-nav>
        <b-nav-item
          v-if="oidcIsAuthenticated"
          to="/tenants"
          active-class="active"
          class="text-truncate"
        >
          TENANTS
        </b-nav-item>
        <b-nav-item
          v-if="oidcIsAuthenticated"
          to="/identityResources"
          active-class="active"
          class="text-truncate"
        >
          IDENTITY RESOURCES
        </b-nav-item>
        <b-nav-item
          v-if="oidcIsAuthenticated"
          to="/apiResources"
          active-class="active"
          class="text-truncate"
        >
          API RESOURCES
        </b-nav-item>
      </b-navbar-nav>

      <div
        v-show="oidcIsAuthenticated"
        class="ml-auto"
      >
        <b-navbar-nav>
          <b-nav-item right>
            <i class="fa fa-user-circle-o" />
            <span class="o-label-sm o-strong text-truncate">{{
              oidcIsAuthenticated ? oidcUser.preferred_username : ""
            }}</span>
          </b-nav-item>
          <b-nav-item
            to
            exact
            right
            @click="signOut"
          >
            <i class="fa fa-sign-out" />
            <span
              class="o-label-sm o-strong d-none d-xl-inline-block text-truncate"
              style="vertical-align: middle"
            >
              &nbsp;&nbsp;&nbsp;Sign Out
            </span>
          </b-nav-item>
        </b-navbar-nav>
      </div>
      <div
        v-show="!oidcIsAuthenticated"
        class="ml-auto"
      >
        <b-navbar-nav>
          <b-nav-item
            to
            exact
            right
            @click="signIn"
          >
            <i class="fa fa-sign-in" />
            <span
              class="o-label-sm o-strong d-none d-xl-inline-block text-truncate"
              style="vertical-align: middle"
            >&nbsp;&nbsp;&nbsp;Sign In
            </span>
          </b-nav-item>
        </b-navbar-nav>
      </div>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Navigation",
  data() {
    return {};
  },
  computed: {
    ...mapGetters("oidcStore", ["oidcUser", "oidcIsAuthenticated"]),
    showAlert: {
      get() {
        return this.$store.getters.showAlert;
      },
      set(value) {
        this.$store.dispatch("showAlert", value);
      },
    },
    alertMessage: {
      get() {
        return this.$store.getters.alertMessage;
      },
      set(value) {
        this.$store.dispatch("alertMessage", value);
      },
    },
  },
  mounted() {
    window.addEventListener(
      "vuexoidc:accessTokenExpiring",
      this.accessTokenExpiring
    );
    window.addEventListener(
      "vuexoidc:accessTokenExpired",
      this.accessTokenExpired
    );
  },
  destroyed() {
    window.removeEventListener(
      "vuexoidc:accessTokenExpiring",
      this.accessTokenExpiring
    );
    window.removeEventListener(
      "vuexoidc:accessTokenExpired",
      this.accessTokenExpired
    );
  },

  methods: {
    ...mapActions("oidcStore", [
      "authenticateOidcSilent",
      "authenticateOidcPopup",
      "removeOidcUser",
      "signOutOidc",
      "signOutOidcSilent",
    ]),
    signIn: function () {
      this.$router.push("tenants");

      // console.log("SignIn");
      // this.authenticateOidcPopup()
      //   .then(() => {
      //     this.$router.push("/");
      //     location.reload();
      //   })
      //   .catch(() => this.removeOidcUser());
    },
    signOut: function () {
      console.log("Sign out");
      this.signOutOidc().then(() => this.removeOidcUser());
    },
    accessTokenExpiring: function () {
      console.log("accessTokenExpiring...");
    },
    accessTokenExpired: function () {
      console.log("access token is expired...session expired");
      this.removeOidcUser();
      this.$router.push("/");
    },
  },
};
</script>
